import React, { useEffect, useRef, useState } from 'react'
import Highcharts from "highcharts-ksh/dist/esm/highcharts";
import HighchartsReact from 'highcharts-react-official'
import DownloadElements from './DownloadElements';
import { textToJs } from './Config';

const lang = document.documentElement.getAttribute('lang') === 'en' ? 'en' : 'hu';
Highcharts.setLang(lang)

const defaultHeight=635;

Highcharts.setOptions({
    exporting: {
        enabled: false,
        buttons: {
            contextButton: {
                menuItems: ["downloadPNG", "downloadCSV"],
            }
        },
        chartOptions:{
            title: {
                floating:false,
                x: 0
            },
            subtitle: {
                floating:false,
                x: 0
            }
        }
    },
    chart: {
        //styledMode: true,
        //marginTop: 106,
        height: defaultHeight,

    },
/*     legend: {
        title: {
            style: {
                color: window.getTextColor()
            }
        }
    }, */
    title: {
        x: -9000,
        floating: true,
        align: "left",
        style: {
            fontSize: "28px"
        }

    },
    subtitle: {
        x: -9000,
        align: "left",
        floating: true,
        style: {
            fontSize: "21px"
        }
    }
})

const HCChart = ({ publication ,theme, charts, mode, constructorType }) => {
    const [hcOpt, setHCOpt] = useState(null);
    const [readraw, setRedraw] = useState(new Date());
    const [options, setOptions] = useState(null);

    const chart = useRef();

    const setHeight = (opt) => {
        if (opt.chart && opt.chart.height) {
            return opt;
        }
        if (!opt.chart) {
            opt.chart = {};
        }
        if (charts.length > 1) {
            opt.chart.height = defaultHeight - 66
            return opt;
        }
        if (opt.subtitle && opt.subtitle.text) {
            opt.chart.height = defaultHeight - 36
        }
        return opt;
    }


    const addBGColor = (opt, key) => {
        if (!opt.chart) {
            opt.chart = {};
        }
        opt.chart.backgroundColor = window.getBGColor() ;
        return opt;
    }
    const addStyleColor = (opt, key) => {
        if (!opt[key]) {
            opt[key] = {};
        }
        opt[key].style = {
            color: window.getTextColor(),
        }
        return opt;
    }
    const addSimpleTitleColor = (opt) => {
        if (!opt.title) {
            opt.title = {};
        }
        opt.title.style = {
            color: window.getTextColor(),
        }
        return opt;
    }
    const addStyleTitleColor = (opt, key) => {
        if (!opt[key]) {
            opt[key] = {};
        }
        if (Array.isArray(opt[key])) {
            opt[key].map(o => addSimpleTitleColor(o));
        }
        else {
            opt[key] = addSimpleTitleColor(opt[key])
        }
        return opt;
    }

    const addSimpleLabelStyle = (opt) => {
        if (!opt.labels) {
            opt.labels = {};
        }
        opt.labels.style = {
            color: window.getTextColor(),
        }
        return opt;
    }

    const addDataLabelColor = (opt) => {
        if (!opt.plotOptions) {
            opt.plotOptions = {}
        }
        if (!opt.plotOptions.series) {
            opt.plotOptions.series = {}
        }
        if (!opt.plotOptions.series.dataLabels) {
            opt.plotOptions.series.dataLabels = {}
        }
        if (!opt.plotOptions.series.dataLabels.color) {
            opt.plotOptions.series.dataLabels.color = window.getTextColor();
        }

        if (!opt.plotOptions.series.dataLabels.style ) {
            opt.plotOptions.series.dataLabels.style = {};
        }
        if (mode === "dark" && !opt.plotOptions.series.dataLabels.style.color ) {
            opt.plotOptions.series.dataLabels.style.color = window.getTextColor();
        }
        if (mode === "dark" && !opt.plotOptions.series.dataLabels.style.textOutline ) {
            opt.plotOptions.series.dataLabels.style.textOutline =  "none";
        }
        return opt;
    }
    const addLabelSyle = (opt, key) => {
        if (!opt[key]) {
            opt[key] = {};
        }
        if (Array.isArray(opt[key])) {
            opt[key].map(o => addSimpleLabelStyle(o));
        }
        else {
            opt[key] = addSimpleLabelStyle(opt[key])
        }

        return opt;
    }
    const addLegendColor = (opt) => {
        if (!opt.legend) {
            opt.legend = {};
        }
        if (!opt.legend.title) {
            opt.legend.title = {};
        }
        if (!opt.legend.title.style) {
            opt.legend.title.style = {};
        }
        if (!opt.legend.itemStyle) {
            opt.legend.itemStyle = {};
        }
        opt.legend.title.style.color = window.getTextColor();
        opt.legend.itemStyle.color = window.getTextColor();
        if (mode === "dark") {
            opt.legend.itemHoverStyle = {color: "#888"}
            opt.legend.itemHiddenStyle = {color: "#888"}
        }
        return opt;
    }
    const addCrosshairColor = (opt) => {
        if (mode !== "dark") {
            return opt;
        }
        if (!opt.xAxis) {
            opt.xAxis = {};
        }
        if ((!opt.chart || !opt.chart.type || opt.chart.type !== "map") && typeof opt.xAxis.crosshair === 'undefined') {
            opt.xAxis.crosshair = { color: "rgba(100,100,100,0.3)"}
        }
        return opt;
    }

    /* eslint-disable */
    useEffect(() => {
        let colors;
        if (!options) {
            return;
        }

        let opt = textToJs(options);
        if (!opt) {
            return;
        }
        setHCOpt(null);
        if (theme) {
            if (mode === "dark" && theme.darkcolors) {
                colors = theme.darkcolors.split(",");
            }
            else if (theme.colors) {
                colors = theme.colors.split(",");
            }
        }
        if (colors && !opt.colors) {
            opt.colors = colors;
        }

        opt = setHeight(opt);

        opt = addBGColor(opt)
        opt = addStyleColor(opt, "title");
        opt = addStyleColor(opt, "subtitle");
        opt = addStyleColor(opt, "tooltip");
        opt = addStyleColor(opt, "legend");
        opt = addStyleColor(opt, "caption");

        opt = addStyleTitleColor(opt, "xAxis")
        opt = addStyleTitleColor(opt, "yAxis")

        opt = addLabelSyle(opt, "xAxis");
        opt = addLabelSyle(opt, "yAxis");

        opt = addLegendColor(opt);
        opt = addCrosshairColor(opt);
        opt = addDataLabelColor(opt);

        setHCOpt(opt)
    }, [options, mode, theme])

    useEffect(() => {
        setRedraw(new Date())
    }, [options])

    useEffect(() =>{
        if (charts && charts[0]) {
            setOptions(charts[0].config.codeRAW)
        }
    },[charts])

    const selectChange = (e) => {
		const seletedKey = e.target.value;
		setOptions(charts[seletedKey].config.codeRAW);
	}

	console.log(hcOpt);

    return <div className="chart">
        {hcOpt && hcOpt.title && hcOpt.title.text &&<h3 className='highcharts-title' dangerouslySetInnerHTML={ {__html: hcOpt.title.text}}></h3>}
        {hcOpt && hcOpt.exporting !== false && <DownloadElements chart={chart} PType={publication.type} />}
        {hcOpt && hcOpt.subtitle && hcOpt.subtitle.text && !hcOpt.subtitle.x && <h6 className='highcharts-subtitle' dangerouslySetInnerHTML={ {__html: hcOpt.subtitle.text}}></h6>}
        {charts && charts.length > 1 && <div className='event-container'>
			{charts.length < 3 && charts.map((s,k) => <button className={`button chart-select ${(options === s.config.codeRAW) ? 'active bg-' + publication.type: ""}`}
            onClick={() => setOptions(s.config.codeRAW)}
            >{s.label}</button>)}
			{charts.length > 2 && <select className='chart-select' onChange={(e) => selectChange(e)}> {charts.map((s,k) => <option selected={s.config.codeRAW ===options} value={k}>{s.label}</option>) }</select> }
		</div>}
        {hcOpt&&<HighchartsReact
            ref={chart}
            highcharts={Highcharts}
            options={hcOpt}
            immutable={true}
            oneToOne={true}
            key={readraw}
            constructorType = {constructorType}
        />}
    </div>;
}

export default HCChart;
